// extracted by mini-css-extract-plugin
module.exports = {"stockList":"stockList-3_zQonQI","red":"red-27N_i4wi","current":"current-2pqcJpuB"};